import { jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './Link.module.css.js';

const Link = ({ children, ...attrs }) => {
    let rel = attrs.rel;
    if (attrs.target === "_blank") {
        rel = rel ?? "noreferrer noopener";
    }
    return (jsx("a", { ...attrs, className: classNames(style.link, attrs.className), rel: rel, children: children }));
};
Link.displayName = "Link";

export { Link };
//# sourceMappingURL=Link.js.map
